// extracted by mini-css-extract-plugin
export default {"section":"Roadmap-module__section__MFaTg","tableWrapper":"Roadmap-module__tableWrapper__XdZUl","footerWrapper":"Roadmap-module__footerWrapper__wRmMp"};